



























































import Vue from 'vue';
import Component from 'vue-class-component';
import { mapGetters, mapState } from 'vuex';
import CreditCard from '@/components/CreditCard.vue';
import SecureCard from '@/components/SecureCard.vue';
import CreditCardModel from '@/models/CreditCard';
import Customer from '@/models/Customer';

const Setup = Vue.extend({
	name: 'CreditCardSelector',
	components: {
		CreditCard,
		SecureCard,
	},
	props: {
		allowNewCard: { type: Boolean, default: true },
		captcha_token: String,
		validateCard: Boolean,
		refresh_happened: { type: String, default: null },
	},
	computed: {
		...mapGetters(['customer']),
	},
	watch: {
		validateCard(value: boolean) {
			if (value) {
				(this as CreditCardSelector).performValidation();
			}
		},
	},
});

@Component
export default class CreditCardSelector extends Setup {
	// Props
	public allowNewCard!: boolean;
	public captcha_token!: string;
	public validateCard!: boolean;

	// Data
	public newCard: CreditCardModel = new CreditCardModel();
	public selectedCard: CreditCardModel | null = null;
	public validate: boolean = false;
	public count: number = 1;

	// State
	public customer!: Customer;

	public created() {
		this.selectedCard = this.customer.primaryCard || this.customer.secondaryCard;
	}

	public get cards(): CreditCardModel[] {
		return this.customer.credit_cards;
	}

	public get isOnlyNewCard(): boolean {
		return !this.cards.length;
	}

	public get selectedNewCard(): boolean {
		return !!this.selectedCard && this.selectedCard.token === this.newCard.token;
	}

	public onTokenizeCard(card: CreditCardModel) {
		console.log('Card Tokenized...');
		this.validate = false;
		if (card.token) {
			this.$emit('validated-card', card);
		} else if (card.errors && card.errors.creditCard === "Encountered an issue charging/storing your card. Please review your card's details and try again.") {
			this.reset_form();
		}
	}

	public async reset_form() {
		// Wait for the change to get flushed to the DOM
		if (this.count <= 5) {
			this.$nextTick(() => {
				this.refresh_happened = `Invalid card data. Please try again (Attempt: ${this.count}).`;
				this.count = this.count + 1;
			});
		} else {
			this.refresh_happened = 'Maximum attempts reached, Refresh and try again.';
		}
	}

	public performValidation() {
		if (this.selectedCard && !this.selectedNewCard) {
			this.$emit('validated-card', this.selectedCard);

			return;
		}

		if (this.selectedNewCard || this.isOnlyNewCard) {
			this.validate = true;
		}
	}

	public cardSelected(card: CreditCardModel) {
		this.$store.dispatch('googleEvents/clickedChooseCreditCard', 'chosen_card');
		this.$emit('selected-card', card)
	}
}
